export { default } from 'ember-loading/services/loading';
